<template>
  <div class="heart-analyzer">
    <header class="header">
          <h1 class="title">心 动 吗</h1>
            <p class="subtitle">
              <div @click="showImage = true">
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请务必点击这里，查看购买后展示图~</p>
              </div>
            </p>

            <div v-if="showImage" class="modal" @click="showImage = false">
              <img :src="require('@/assets/idshow.jpg')" class="modal-image" @click.stop>
            </div>
        </header>

    <div class="main-content">
      <div v-if="!analysisResults" class="upload-section">

        <label for="file-upload" class="file-upload-btn">
          选择照片
        </label>
        <input id="file-upload" type="file" @change="handleFileUpload" accept="image/*" style="display: none;" />

        <div v-if="imageUrl" class="preview-section">
          <img :src="imageUrl" alt="预览图片" class="preview-image" />
        </div>
        <p>  </p>
        <input v-model="name" placeholder="请输入照片名称进行标记" class="name-input" />
        <div class="action-buttons">
          <button @click="gotoPay" :disabled="!imageUrl" class="analysis-btn">开始分析  ¥5.20</button>
          <button @click="goToList" class="list-btn">查看购买记录</button>
        </div>
        <div v-if="!analysisResults" class="additional-info">
          <p>说明：</p>
          <p>·心动吗是一款基于微表情的情感分析工具，旨在帮助用户了解自己和他人之间的情感状态。</p>
          <p>·所有的分析结果代表的是，在拍这张照片前后一段时间内，照片中人对对方和对环境的态度。这种态度是会随着时间改变而改变的。</p>
          <p>·从一张照片中，看出他是不是喜欢你，他的付出欲望有多少。</p>
          <p>·上传两张不同时期的合照，还可以看出在不同时期中他对你的感情变化如何。</p>
          <p>·上传两张不同人的合照，还可以看出谁更加喜欢你。</p>
          <p>·也可以看出，对方在你面前是爱付出，还是求回报。</p>
          <p>·单人照在公众号即可免费测试，这里只测试二人照和三人照。</p>
          <p>·系统资源有限，计算量庞大，所以可能会稍有延迟，感谢理解。</p>
        </div>
      </div>

      <div v-if="analysisResults" class="results-section">
        <div class="preview-section">
          <img :src="'http://www.miaoxingjundd.com/facecache/' + otherResults.path" alt="分析图片" class="preview-image" />
        </div>

        <div class="analysis-results">
          <h3>分析结果：在拍摄这张照片前后一段时间内，</h3>
          <p><strong>{{ analysisResults.peoplenum }}个人的行动想法与心态：</strong></p>
          <p>{{ analysisResults.caiword }}</p>
          <p>{{ analysisResults.yinword }}</p>
          <h3><strong>两个人在想法和心态上的比较：</strong></h3>
          <p><strong>1.{{ analysisResults.maxcai }}</strong><br></p>
          <p>注①：主导欲望意味着希望自己在这段关系中有更高的决策地位，如果对方不听他的，他心里就会很难受。如果在交往中，这{{analysisResults.maxcailen}}个人主导欲望一直很强，那么则可以通过适时满足来控制对方的情绪。<br><br></p>
          <p><strong>2.{{ analysisResults.mincai }}</strong><br></p>
          <p>注③：这说明这{{analysisResults.mincailen}}个人能从当下环境或者另一个人中获得安全感，而这种安全感也会转化为依赖心理。如果在暧昧期，这{{analysisResults.mincailen}}个人是有着比较强的对对方的依赖心理。可以尝试换个环境，分析双方对人的依赖心理。<br><br></p>
          <p><strong>3.{{ analysisResults.maxyin }}</strong><br></p>
          <p>注②：这说明当下的环境可以让这{{analysisResults.maxyinlen}}个人长时间的保持耐心，或者说这{{analysisResults.maxyinlen}}个人在这个环境中更容易接受另一个人的各种要求。<br><br></p>          
          <p><strong>4.{{ analysisResults.minyin }}</strong><br></p>
          <p>注④：这说明这{{analysisResults.minyinlen}}个人从情绪上来说是相对来说更不喜欢对方的，但如果在3中这{{analysisResults.minyinlen}}个人有安全感而在这里缺失亲密感，则很大概率是因为有心事，玩累了等等自身因素。如果在暧昧期，这{{analysisResults.minyinlen}}个人是不喜欢对方的状态。<br><br></p>
          <div class="detail-section">
            <h4><br>付出欲望：</h4>
            <ul>
              <li v-for="(item, index) in analysisResults.giving" :key="'giving'+index"><strong>{{ item }}</strong></li>
            </ul>
            <p><br>注⑤：付出欲望代表了一个人对另一个人的物质付出欲望，两者或者三者中物质欲望最高的那个人是很在意对方如何看自己的。可以从这张照片之后拍的照片中分析查看其付出欲望，付出欲望越高，则说明这个人在对方身上有急于索取的精神上的东西。结合第三点与第四点，可以推断出这个人对对方的态度。不喜欢+低付出欲说明自己的问题导致心态不好。不喜欢+高付出欲会更快地分开。<br><br></p>
          </div>

          <div class="detail-section">
            <h4><br>回报期望：</h4>
            <ul>
              <li v-for="(item, index) in analysisResults.receiving" :key="'receiving'+index"><strong>{{ item }}</strong></li>
            </ul>
            <p><br>注⑥：回报期望对应付出欲望，回报期望越高，越希望从对方身上得到物质的满足。回报期望也代表了心态的稳定性，即汇报期望越高，和对方的情感是稳定的。即便是呈现这个人不喜欢的状态，也不会在很短时间内分开。<br><br></p>

          </div>

          <div class="detail-section">
            <h4><br>耐心：</h4>
            <ul>
              <li v-for="(item, index) in analysisResults.changing" :key="'changing'+index"><strong>{{ item }}</strong></li>
            </ul>
            <p><br>注⑦：耐心代表了这个人在当下的环境和在对方身边时的耐心程度。可以从这张照片之后拍的照片中分析查看其耐心程度，耐心程度越高物质付出越低，耐心程度越低，物质付出越高。<br><br></p>
          </div>
        </div>

        <div class="action-buttons">
          <button @click="resetAnalysis" class="reset-btn">返回</button>
          <button @click="goToList" class="list-btn">查看购买记录</button>
        </div>        
      </div>
    </div>

    <div v-if="showInfoImage" class="modal" @click="hideImage">
      <img src="https://example.com/info-image.jpg" alt="Info" class="modal-image" @click.stop>
    </div>

    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>正在进行分析，请不要关闭或退出页面</p>
      <p>平均每一个人需要4秒钟</p>
    </div>   
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { ImagePreview,Toast } from 'vant';
import {getAction,postAction} from '@/api/manage';
import { Dialog } from 'vant';
import { ref } from 'vue';

export default {
  name: 'heartresultweibo',
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      showImage: false,
      imageUrl: null,
      filename: '',
      uploadStatus: null,
      name: '',
      analysisResults: null,
      otherResults: null,
      showInfoImage: false,
      pay: 0,
      isLoading: ref(false),
    };
  },
  computed:{
    weiboid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getweiboid || '';
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
    name(){
      return this.$route.query.name || ''
    },
    filename(){
      return this.$route.query.filename || ''
    }
  },
  mounted(){
    if(!this.weiboid){
      if(!this.code){
        var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/heartresultweibo')
        window.location.href=`https://api.weibo.com/oauth2/authorize?client_id=3852406503&response_type=code&redirect_uri=`+ url
      } else {
         this.getJsLogin()
      }
    } else {
        // this.init()
        // this.getLoveSingle()
    }
  },
  created() {
    this.otherResults = this.$route.params.analysisData || '';
    this.analysisResults = this.otherResults.resword || '';    
    this.init()
  },
  methods: {
    init(){
      if(this.$route.query.paytrue){
        this.name = this.$route.query.name || ''
        this.filename = this.$route.query.filename || ''
        this.pay = 1
        this.getRecord()
      }
    },
    imageView(){
      ImagePreview({images:['http://www.miaoxingjundd.com/facecache/idshow.jpg'], closeable: true});
    },
    handleFileUpload(event) {
      const files = event.target.files
      if (files.length > 0) {
        const file = files[0]
        this.filename = file.name
        this.previewImage(file)
        this.uploadImage(file)
      }
    },
    previewImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    async uploadImage(file) {
      const formData = new FormData()
      formData.append('pic', file)

      try {
        this.isLoading = true
        const response = await postAction('/pic/face/upload', formData)
        this.isLoading = false
        alert(response.data.msg)
        if(response.data.code == 200) {
          if(!response.data.msg.includes('成功')){
            this.filename = ''
            this.imageUrl = null
          }
        }
      } catch (error) {
        this.isLoading = false
        this.uploadStatus = { type: 'error', message: '上传失败' }
        this.filename = ''
        this.imageUrl = null
      }
    },
    async getRecord() {
      const url = '/ai/face/heartresult'
      try {
        this.isLoading = true
        const resp = await postAction(url, {
          filename: this.filename,
          unionid: this.weiboid,
          name: this.name,
          timestamp: new Date().getTime(),
          pay: this.pay
        })
        this.isLoading = false
        if (resp.data.code == 200) {
          this.otherResults = resp.data.msg
          this.analysisResults = resp.data.msg.resword
        }
      } catch (error) {
        alert('获取分析结果失败')
        console.error('获取分析结果失败:', error)
      }
    },
    getJsLogin(){
        const url = '/wbfunc/wblogin'
        postAction(url, {code:this.code}).then( res => {
          this.userInfo = res.data.data
          this.$store.commit("setweiboid", this.userInfo.id);
          this.$store.commit("setweiboname", this.userInfo.name);
          this.$store.commit("setweiboimg", this.userInfo.cover_image_phone);
          this.$store.commit("setweibofoll", this.userInfo.followers_count);
          this.$store.commit("setweibodomin", this.userInfo.description);
              const url2 = '/wbfunc/wblogin/islg'
              postAction(url2, {code:this.userInfo.id}).then( res => {
                if(res.data.code == 200){
                  alert('登录成功')
                } else {
                  this.$router.push({path:'/weibofaceRegister'})
                }
              })
        })
    },
    getLoveSingle(){
        const url = '/wbfunc/wbduanze/getInfo'
        postAction(url, {weiboid:this.weiboid}).then(res => {
          if (res.data.code == 200) {
              this.info = res.data.msg
              this.username = this.info.name
              this.datetime = this.info.birthday
              this.provincecity = this.info.city
              this.sex = this.info.sex
              this.status = this.info.status
              this.disabledFlag = true
          }
        })
    },
    //支付接口
    gotoPay() {
      if (!this.name) {
        alert('请输入名称')
        return
      }
      alert('支付后请不要关闭页面，否则无法完整分析结果')
      const vurl = '/pic/lock';
      postAction(vurl).then(res => {
        if(res.data.code == 200) {
          const that = this
          if (this.filename || this.name) {
            this.$router.push({path:'/heartAlipay',query:{
              name: that.name.toString(),
              filename: that.filename.toString(),
              }
            })
          }else{
            alert('请上传图片，输入名称')
          }      
        }else{
          if(res.data.msg) {alert(res.data.msg)}else{alert('请等待一会再试')}
        }
      })
      
    },
    goToList() {
      this.$router.push({ path: '/heartlistweibo' });
    },
    resetAnalysis() {
      this.imageUrl = null;
      this.filename = '';
      this.name = '';
      this.analysisResults = null;
      this.otherResults = null;
    },
    showImage() {
      this.showInfoImage = true;
    },
    hideImage() {
      this.showInfoImage = false;
    },
  },
  watch: {
    '$route.params.analysisData': function(newData) {
      if (newData) {
        this.analysisResults = newData.resword;
        this.otherResults = newData;
      }
    }
  },
}
</script>

<style scoped>
.heart-analyzer {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #fff0f5;
  min-height: 100vh;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.title {
  font-size: 3em;
  color: #ff1493;
  margin-bottom: 10px;
  letter-spacing: 1.8em; /* 增加字间距 */
  text-align: center;
  writing-mode: horizontal-tb; /* 确保文字横向排列 */
  text-orientation: mixed; /* 确保文字横向排列 */
}

.subtitle {
  font-size: 1.2em;
  color: #ff69b4;
}

.subtitle a {
  color: #ff1493;
  text-decoration: none;
}


.main-content {
  background-color: #fff;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.name-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 2px solid #ff69b4;
  border-radius: 5px;
}

.file-upload-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #ff69b4;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.preview-section {
  margin: 20px 0;
  text-align: center;
}

.preview-image {
  max-width: 300px;
  max-height: 300px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.analysis-btn, .list-btn, .reset-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.analysis-btn {
  background-color: #ff1493;
  color: white;
}

.list-btn {
  background-color: #ff69b4;
  color: white;
}

.reset-btn {
  background-color: #ffb6c1;
  color: #ff1493;
}

.analysis-results {
  margin-top: 30px;
  text-align: left;
}

.analysis-results h3 {
  color: #ff1493;
  text-align: left;
}

.analysis-results p {
  margin: 10px 0;
  text-align: left;
}

.detail-section {
  margin-top: 20px;
  text-align: left;
}

.detail-section h4 {
  color: #ff69b4;
  text-align: left;
}

.detail-section ul {
  padding-left: 20px;
  text-align: left;
  line-height: 1.8; /* 增加行高 */
}

.detail-section li {
  margin-bottom: 10px; /* 在每个列表项之间添加间距 */
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
}

@media (max-width: 600px) {
  .action-buttons {
    flex-direction: column;
  }

  .action-buttons button {
    margin-bottom: 10px;
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  color: black; /* 修改字体颜色为黑色 */
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
}
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #fff;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.additional-info {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
  color: #666;
  font-size: 0.7em;
}
</style>